import _ from "lodash";

export const entity = {
    name: 'Part',
    facets: [{name: 'codeName', codeUniqueWith: 'product'}],
    fields: [
        'Product',
        'description',
        {path: 'state', type: 'Status'},
        {
            path: 'productAndName',
            fieldPath: ['product.code', 'name'],
            f: function() {
                return `${_.get(this, 'product.code', '')} › ${this.name}`
            }
        }
    ],
    filters: [
        {
            name: 'byState',
            path: 'state',
            object: 'Status',
            display: 'name',
            isDefault: false,
            client: true,
            query: function(context) {
                const state = _.get(context, 'data.state.id');
                return state ? {state} : {};
            }
        },
        {
            name: 'onlyActive',
            isDefault: false,
            query: function() {
                return {state: 'actif'}
            }
        }
    ]
}

export const module_ = {
    object: 'Part',
    category: {
        path: 'catalog',
        icon: 'package'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'product', display: 'fullName'},
            'code',
            'name',
            {path: 'state', initiallyNotVisible: true}
        ],
        form: [
            {path: 'product', display: 'fullName', placeholder: 'sélectionner le produit'},
            {path: 'code', placeholder: 'renseigner un code unique dans le produit', noSpaces: true},
            {path: 'name', placeholder: 'renseigner le nom du processus / de la partie'},
            {path: 'description', tKey: 'synthèse', type: 'richTextEditor'},
            {path: 'state', type: 'toggle', default: {id: 'actif'}}
        ]
    },
    filters: [
        {
            path: 'product',
            object: 'Product',
            display: 'fullName',
            client: true,
            clearable: true,
            placeholder: 'selectProduct',
            default: {id: null},
            query: function(context) {
                const productId = _.get(context.data, 'product.id')
                return productId ? {product: new global.ObjectID(productId)} : {}
            }
        },
        'byState'
    ]
}
